<template>
    <div>
      <h3>Business Information</h3>
      <Dropdown
        :inputField="inputs.general_industry"
        :options="generalIndustryOptions"
        inputName="General Industry"
        inputType="string"
        v-if="isNeeded('general_industry')"
      />
      <Dropdown
        :inputField="inputs.industry"
        :options="industryOptions"
        inputName="Industry"
        inputType="string"
        v-if="isNeeded('industry')"
      />
      <Input
        :inputField="inputs.justification"
        inputName="Provide a brief description of what your business does."
        inputType="string"
        v-if="isNeeded('justification')"
      />
      <Input
        @enter="next"
        :inputField="inputs.website"
        inputName="Business Website or Social Media Page"
        inputType="string_empty"
        :icons="{ left: 'fa-globe' }"
        v-if="isNeeded('website')"
      />
      <h3 v-if="isNeeded('start_date')">Business Start Date</h3>
      <Dropdown
        :inputField="inputs.startMonth"
        :options="monthOptions"
        inputName="Month"
        inputType="string"
        v-if="isNeeded('start_date')"
      />
      <Input
        @enter="next"
        :inputField="inputs.startYear"
        inputName="Year"
        inputType="year"
        v-if="isNeeded('start_date')"
      />
      <Choices
        :inputField="inputs.products"
        inputName="What are you interested in?"
        inputType=""
        :options="[
            'Working Capital',
            'Credit Line', 
            'Invoice Factoring',
            'Equipment Financing',
            'Vehicle Financing'
          ]"
      />
      <AddressInput
        :inputField="inputs.address"
        inputName="Home Address"
        inputType="string"
        @selectedAddress="updateAddress"
        v-if="isNeeded('street')"
      />
      <Input
        @enter="next"
        :inputField="inputs.city"
        inputName="City"
        inputType="string"
        ref="city"
        v-if="isNeeded('city')"
      />
      <Input
        @enter="next"
        :inputField="inputs.state"
        inputName="State"
        inputType="state"
        ref="state"
        v-if="isNeeded('stateCode')"
      />
      <Input
        @enter="next"
        :inputField="inputs.zip"
        inputName="Zip Code"
        inputType="zip"
        ref="zip"
        v-if="isNeeded('postalCode')"
      />
      <List
        :inputField="inputs.classification"
        :options="classificationOptions"
        inputName="Business Classification"
        inputId="classification"
        :fullWidthOption="false"
        v-if="isNeeded('classification')"
      />
      <div class="buttons is-right">
        <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
        <a class="button is-link padded-button next-button" @click="next"
          >Continue</a
        >
      </div>
    </div>
  </template>
  
  <script>
  import Input from "@/components/shared/Input";
  import Dropdown from "@/components/shared/Dropdown";
  import ApplyPage from "@/components/shared/ApplyPage";
  import Choices from "@/components/shared/Choices";
  import List from "@/components/shared/List";
  import AddressInput from "@/components/shared/AddressInput";
  export default {
    name: "IncompleteAppCompanyFields",
    components: {
      Input,
      Dropdown,
      Choices,
      AddressInput,
      List
    },
    props: {
      fields_incomplete: Array
    },
    mixins: [ApplyPage],
    data() {
      return {
        obj: "business",
        inputs: {
          industry: Input.model(),
          general_industry: Input.model(),
          website: Input.model(),
          startMonth: Input.model(),
          startMonthNumber: 1,
          startYear: Input.model(),
          products: Input.model(),
          justification: Input.model(),
          loanuse: Input.model(),
          address: AddressInput.model(),
          city: Input.model(),
          state: Input.model(),
          zip: Input.model(),
          classification: Input.model(),
        },
        monthOptions: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        industryOptions: [
          "Accounting",
          "Agriculture",
          "Alarm Company",
          "Automobile",
          "Auto Repair",
          "Automobile Sales",
          "Business Services",
          "Car Service/Limousine",
          "Chiropractic Treatment",
          "Clothing Store",
          "Computer/Electronics",
          "Consumer Services",
          "Convenient Store",
          "Construction",
          "Daycare",
          "Delivery service/Local",
          "Dry cleaners",
          "E-Commerce",
          "Education",
          "Electrician/Electrical Work",
          "Energy",
          "Excavating",
          "Facility Maintenance/Cleaning",
          "Financial Services",
          "Flooring",
          "Food Service",
          "Funeral Home/Cremation Services",
          "Government",
          "Grocery Store",
          "Gym",
          "Handyman/Repair",
          "HVAC",
          "Health/Pharmaceuticals",
          "Health/Fitness/Spa",
          "Home Care/Treatment Facility",
          "Hospitality",
          "IT Services",
          "Landscaping",
          "Lawyer/Attorney",
          "Liquor Store",
          "Manufacturing",
          "Marketing Firm/Public Relations",
          "Mining",
          "Media/Entertainment",
          "Medical/Dental",
          "Moving Company",
          "Non-Profit",
          "Oil And Gas",
          "Painter",
          "Pest Control",
          "Pet Care",
          "Plumbing/Heating",
          "Pool Design/Driveway/Paving",
          "Property Management",
          "Real Estate",
          "Restaurant",
          "Retail",
          "Roofing",
          "Staffing/HR Services",
          "Security Service",
          "Software/Internet",
          "Spa/Salon",
          "Storage/Containers",
          "Telecommunications",
          "Towing",
          "Training/Sports Recruitment",
          "Transportation",
          "Travel/Leisure",
          "Utilities",
          "Vape Shop/Tobacco Shop",
          "Wholesale/Distribution",
          "Welding",
          "Wildlife Preservation/Fire Safety",
          "Window/Garage/Paving Installation",
          "Window Cleaning /Pressure Washing",
          "Other",
        ],
        classificationOptions: [
          "Sole Proprietorship",
          "Partnership",
          "LLC",
          "C Corporation",
          "S Corporation",
        ],
        generalIndustryOptions: [
          "Retail",
          "Restaurants and Food Services",
          "Healthcare",
          "Hospitality",
          "Automotive",
          "Professional Services",
          "Construction and Contracting",
          "Beauty and Wellness",
          "E-commerce",
          "Manufacturing",
          "Transportation and Logistics",
          "Education and Childcare",
          "Real Estate",
          "Technology",
          "Wholesale",
          "Non-profits",
          "Auto Sales",
          "Other Services",
        ],
      };
    },
    mounted: function () {
    },
    methods: {
        isNeeded(inputId) {
        // console.log(inputId);
        // Check if the input ID is in the hiddenInputs array
        return this.fields_incomplete.includes(inputId);
    },
    },
    watch: {
      inputs: {
        deep: true,
        handler(newValue, oldvalue) {
          if (newValue.startMonth.value != "") {
            // console.log(newValue.startMonth.value);
            this.inputs.startMonthNumber =
              this.monthOptions.indexOf(newValue.startMonth.value) + 1;
            console.log(this.inputs.startMonthNumber);
          }
        },
      },
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  